import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Switch,
  InputNumber,
  DatePicker,
  Row,
  Col,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AiFillDelete, AiOutlineUnlock } from "react-icons/ai";
import ProductsModal from "../components/ProductsModal";
import moment from "moment";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import debounce from "lodash.debounce";
import promotionApi from "../api/promotionApi";
import Swal from "sweetalert2";

const dataExample = {
  name: null,
  status: false,
  startDate: null,
  endDate: null,
  description: null,
  Picker: null,
};

const Promotion = (props) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;
  const { RangePicker } = DatePicker;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState();
  const [isEditModal, setIsEditModal] = useState(false);
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [listDeleted, setListDeleted] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isEditModalShow, setIsEditModalShow] = useState(false);

  const [lstPromotion, setLstPromotion] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [productSelects, setProductSelects] = useState([]);

  const [inputFilter, setFilter] = useState({
    name: "",
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const dateFormatUTC = "DD/MM/YYYY";

  useEffect(() => {
    getPromotions();
    form.setFieldsValue(valueForm);
  }, [inputFilter, form, valueForm]);

  const onSelectProducts = (data) => {
    console.log(data);
    setProductSelects(data);
  };

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1, name: e.target.value });
  };

  const getPromotionsDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getPromotions = () => {
    setLoading(true);

    promotionApi.getPromotions(inputFilter).then((res) => {
      if (res?.results) {
        setLstPromotion(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    Table.EXPAND_COLUMN,
    {
      title: "Tên khuyến mãi",
      dataIndex: "name",
    },
    // {
    //   title: "Sản phẩm",
    //   dataIndex: "code",
    //   render: (text) => <h6>{text}</h6>,
    // },
    {
      title: "Ngày bắt đầu",
      dataIndex: "startDate",
      render: (startDate) => (
        <span>{moment(startDate).format(dateFormatUTC)}</span>
      ),
    },
    {
      title: "Ngày kết thúc",
      dataIndex: "endDate",
      render: (endDate) => <span>{moment(endDate).format(dateFormatUTC)}</span>,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deletePromotion(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setProductSelects([]);
    setIsEditModalShow(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (productSelects.length > 0) {
        if (isEditModal) {
          updatePromotion(values);
        } else {
          createPromotion(values);
        }
      } else {
        Swal.fire({
          title: "Thất bại!",
          text: "Vui chọn sản phẩm được khuyến mãi!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },
    [isEditModal, productSelects]
  );

  const createPromotion = (data) => {
    const _productSelects = productSelects.map((item) => {
      return item.id;
    });

    const payload = {
      name: data.name,
      status: data.status,
      startDate: moment(data.Picker[0]),
      endDate: moment(data.Picker[1]),
      description: data.description,
      products: _productSelects,
    };
    console.log(payload);

    promotionApi.createPromotion(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getPromotions();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Tạo thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updatePromotion = (data) => {
    const _productSelects = productSelects.map((item) => {
      return item.id;
    });

    const payload = {
      name: data.name,
      status: data.status,
      startDate: moment(data.Picker[0]),
      endDate: moment(data.Picker[1]),
      description: data.description,
      products: _productSelects,
    };
    console.log("payload", payload);

    promotionApi.updatePromotion(data.id, payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getPromotions();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Sửa thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const showEditModal = (record) => {
    setTitleModal("Sửa khuyến mãi");

    const products = record.products.map((item) => {
      return { id: item.id, name: item.name };
    });

    setProductSelects(products);

    setProductSelects(record.products);
    setValueForm({
      id: record.id,
      name: record.name,
      status: record.status,
      description: record.description,
      Picker: [moment(record.startDate), moment(record.endDate)],
    });
    setIsEditModalShow(true);
    setIsEditModal(true);
  };
  const showCreateModal = () => {
    setTitleModal("Thêm khuyến mãi");
    setValueForm(dataExample);
    setIsEditModalShow(true);
    setIsEditModal(false);
    setProductSelects([]);
    form.resetFields();
  };

  const confirm = Modal.confirm;

  const deletePromotion = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa promotion này không?",
      onOk() {
        promotionApi
          .deletePromotion(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công promotion ");
              getPromotions();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deletePromotions = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các promotion này không?",
      onOk() {
        promotionApi
          .deletePromotion(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công promotion ");
              getPromotions();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên khuyến mãi</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                // value={inputFilter.username}
                placeholder="Nhập tên ..."
                onChange={getPromotionsDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>

            <Col span={6}>
              <label> Trạng thái</label>
              <Select
                value={inputFilter.status}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1, status: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Không hoạt động</Option>
              </Select>
            </Col>
            <Col span={6}></Col>
          </Row>
        </Card>
        <br />
        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm khuyến mãi
          </Button>
          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deletePromotions();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstPromotion}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
              expandable={{
                expandedRowRender: (record) => (
                  <>
                    <p
                      style={{
                        margin: 0,
                      }}
                    >
                      <b> Sản phẩm thuộc khuyến mãi</b> :
                      {record.products.map((item) => {
                        return (
                          <Tag className="my-tag" color="#87d068">
                            {item.name}
                          </Tag>
                        );
                      })}
                    </p>

                    <p
                      style={{
                        margin: 0,
                      }}
                    >
                      <b> Mô tả</b> : {record.description}
                    </p>
                  </>
                ),
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isEditModalShow}
        onOk={form.submit}
        onCancel={() => {
          closePopup();
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item hidden={true} label="Id" name="id">
              <Input />
            </Form.Item>

            <Form.Item
              label="Tên khuyến mãi"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên!",
                },
              ]}
            >
              <Input placeholder="Nhập tên ..." />
            </Form.Item>

            <Form.Item
              label="Sản phẩm"
              tooltip="Sản phẩm được bật khuyến mãi"
              name="products"
            >
              <ProductsModal
                productItems={productSelects}
                onSelectProducts={onSelectProducts}
              />
            </Form.Item>

            <Form.Item
              label="Ngày bắt đầu và kết thúc"
              name="Picker"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn ngày !",
                },
              ]}
            >
              <RangePicker locale={locale} format={dateFormatUTC} />
            </Form.Item>

            <Form.Item label="Mô tả" name="description">
              <TextArea rows={3} />
            </Form.Item>
            <Form.Item label="Trạng thái" valuePropName="checked" name="status">
              <Switch />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default Promotion;
